import React from 'react'
import Icon from 'components/Icon/Icon'
import styles from './PersonalEmailSignUp.module.css'
import Typography from 'components/Typography/Typography'
import Button from 'components/Button/Button'
import CornerLines from "views/common/CornerLines/CornerLines";
import segmentioTracking from "utils/segmentioTracking";
import { useTheme } from "theming";
import { useAuthenticator } from '@aws-amplify/ui-react'
import { PopupModal } from 'react-calendly'

const PersonalEmailSignUp = () => {
  const { signOut } = useAuthenticator(context => [context.authStatus]);
  const [isScheduleWindowOpen, setIsScheduleWindowOpen] = React.useState(false)

  const theme = useTheme();

  const calendlyPageSettings = {
    hideEventTypeDetails: false,
    hideLandingPageDetails: false,
    primaryColor: theme.palette.primary.main,
  }

  return (
    <div className={styles.mainContainer}>
      <div className={styles.cicleBgContainer}>

        <div className={styles.circleBg} />
      </div>
      <div className={styles.header}>
        <Icon name='logoWithNameHorizonal' className={styles.headerLogoHorizontal} />
        <Icon name='logoWithNameVertical' className={styles.headerLogoVertical} />
      </div>
      <div className={styles.personalEmailSignUpContainer}>
        <div className={styles.textsContainer}>
          <Typography color='textPrimary' variant='h2' className={styles.headerTextContainer}>Introduce autonomous to your team</Typography>
          <Typography color='textSecondary' variant='body3' className={styles.secondaryTextContainer}>It looks like you're trying to sign up with your personal email account. Chat with our team to learn how Sedai can help your organization optimize autonomously at scale.</Typography>
        </div>
        <div className={styles.buttonsContainer}>
          <Button className={styles.buttonStyle} color='primary' variant='filled' size='medium' onPress={() => {
            segmentioTracking.scheduleOnboardingCallClick({ current_step_url: window.location.href })
            setIsScheduleWindowOpen(true)
          }}>Schedule a Demo</Button>
          <Button className={styles.buttonStyle} color='textSecondary' size='medium' isFilled={true} onClick={() => signOut()}>Sign up with Work Email</Button>
        </div>
      </div>
      <>
        <PopupModal pageSettings={calendlyPageSettings} open={isScheduleWindowOpen} onModalClose={() => { setIsScheduleWindowOpen(false) }} url='https://calendly.com/sedai-eng/technical-onboarding-help' rootElement={document.getElementById("root")}
        //title prop is used to select the iframe that's generated from popupModal and attach style to it !IMPORTANT please don't change
          iframeTitle="Calendly technical onboarding help"
        />
      </>
      <CornerLines className={styles.cornerLines} />
    </div>
  )
}

export default PersonalEmailSignUp;